module.exports = __webpack_public_path__ + "static/media/ico_sort.6eb0a5f8.svg";